import { render, staticRenderFns } from "./BaseROInput.vue?vue&type=template&id=924ac20e&scoped=true"
import script from "./BaseROInput.vue?vue&type=script&lang=js"
export * from "./BaseROInput.vue?vue&type=script&lang=js"
import style0 from "./BaseROInput.vue?vue&type=style&index=0&id=924ac20e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924ac20e",
  null
  
)

export default component.exports